import { create } from 'zustand';

interface AlertOptions {
  showCancelButton?: boolean;
}

interface AlertStore {
  showAlert: (
    message: string,
    onConfirm?: () => void,
    options?: AlertOptions,
  ) => void;
  hideAlert: () => void;
  visible: boolean;
  message: string;
  onConfirm?: () => void;
  showCancelButton?: boolean;
}

const initialData = {
  message: '',
  visible: false,
  onConfirm: undefined,
  showCancelButton: false,
};

const useAlertStore = create<AlertStore>((set) => {
  return {
    ...initialData,
    showAlert: (
      message: string,
      onConfirm?: () => void,
      options?: AlertOptions,
    ) => {
      return set({
        visible: true,
        message,
        onConfirm,
        showCancelButton: options?.showCancelButton,
      });
    },
    hideAlert: () => {
      return set({
        ...initialData,
        visible: false,
      });
    },
  };
});

export default useAlertStore;
